import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolume = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_12334_57188",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_12334_57188)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.25503 5.96011L7.91525 3.08151C7.97967 3.03456 8.05593 3.00669 8.13537 3.00106C8.2148 2.99543 8.29421 3.01228 8.36457 3.04968C8.43493 3.08708 8.49341 3.14354 8.53337 3.21263C8.57332 3.28171 8.59314 3.36066 8.59056 3.44049V13.58C8.58935 13.6581 8.56678 13.7343 8.52532 13.8005C8.48386 13.8666 8.42509 13.92 8.35543 13.955C8.28577 13.9899 8.20789 14.005 8.13027 13.9986C8.05265 13.9922 7.97828 13.9645 7.91525 13.9186L4.25503 11.04H2.68829C2.24053 11.04 1.81111 10.8616 1.49449 10.5441C1.17787 10.2265 1 9.7958 1 9.34671V7.65341C1 7.20432 1.17787 6.77362 1.49449 6.45607C1.81111 6.13851 2.24053 5.96011 2.68829 5.96011H4.25503ZM10.4544 6.78644C10.8878 7.25128 11.1291 7.8637 11.1298 8.50006C11.1292 9.14031 10.8797 9.7551 10.4342 10.2137C10.4318 10.2167 10.4287 10.2207 10.4251 10.2254C10.3879 10.274 10.2889 10.4033 10.1843 10.4033C10.1562 10.4033 10.1285 10.3977 10.1026 10.3867C10.0768 10.3758 10.0534 10.3597 10.0338 10.3395C10.0143 10.3192 9.99903 10.2953 9.98892 10.269C9.97881 10.2428 9.97406 10.2147 9.97497 10.1866V6.79999C9.97497 6.7443 9.99702 6.6909 10.0363 6.65152C10.0755 6.61214 10.1288 6.59002 10.1843 6.59002C10.2811 6.59002 10.3827 6.70553 10.4324 6.76209C10.4417 6.77263 10.4491 6.78113 10.4544 6.78644ZM10.1023 4.39981C10.016 4.26762 9.9697 4.11325 9.96887 3.95527C9.96629 3.80403 10.0035 3.65478 10.0768 3.52257C10.1501 3.39036 10.2568 3.27988 10.3863 3.20226C10.5157 3.12463 10.6633 3.08262 10.8141 3.08045C10.9649 3.07828 11.1136 3.11603 11.2452 3.1899C12.2337 3.6784 13.0661 4.4347 13.6482 5.37318C14.2303 6.31166 14.5388 7.39483 14.5388 8.50009C14.5388 9.60534 14.2303 10.6885 13.6482 11.627C13.0661 12.5655 12.2337 13.3218 11.2452 13.8103C11.1147 13.876 10.9696 13.9072 10.8237 13.901C10.6778 13.8948 10.5359 13.8512 10.4115 13.7746C10.287 13.6979 10.1841 13.5907 10.1126 13.463C10.041 13.3353 10.0032 13.1914 10.0026 13.0449C10.0005 12.8906 10.0418 12.7388 10.1218 12.607C10.2019 12.4752 10.3174 12.3687 10.4551 12.2998C11.1718 11.9586 11.7774 11.4204 12.2013 10.7478C12.6253 10.0753 12.8504 9.29583 12.8504 8.50009C12.8504 7.70434 12.6253 6.92492 12.2013 6.25232C11.7774 5.57973 11.1718 5.04157 10.4551 4.70032C10.3111 4.63635 10.1886 4.53199 10.1023 4.39981Z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgVolume);
export default ForwardRef;
